const BASE = process.env.ENV === 'preview' ? 'api/gp-stock-staging' : 'api/gp-stock'
const urls = {
  /*
  * 个股研报详情
  * */
  reportStock: 'get /api/stock/stockChannel/page/reportDetail'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/gp-stock.js